import React, { useEffect, useRef } from 'react';
import NavContent from './NavContent';

const FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])';

const Sidebar = ({ show, setMenuState }) => {
  const panelRef = useRef();
  const previousFocus = useRef(null);

  useEffect(() => {
    if (!show) return;
    previousFocus.current = document.activeElement;

    const el = panelRef.current;
    if (el) {
      const first = el.querySelector(FOCUSABLE);
      if (first) first.focus();
    }

    const handleKeyDown = (e) => {
      if (e.key === 'Escape') {
        setMenuState(false);
        return;
      }
      if (e.key !== 'Tab' || !el) return;
      const nodes = el.querySelectorAll(FOCUSABLE);
      if (nodes.length === 0) return;
      const first = nodes[0];
      const last = nodes[nodes.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
      previousFocus.current?.focus();
    };
  }, [show, setMenuState]);

  return (
    <>
      <div
        className={`sidebar-backdrop ${show ? 'sidebar-backdrop--visible' : ''}`}
        onClick={() => setMenuState(false)}
        aria-hidden="true"
      />
      <nav
        ref={panelRef}
        className={`sidebar-panel ${show ? 'sidebar-panel--open' : ''}`}
        aria-label="Main navigation"
        aria-hidden={!show}
      >
        <NavContent setMenuState={setMenuState} />
      </nav>
    </>
  );
};

export default Sidebar;
